import { Box, Button, TextField } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

type AddTestPageNavButtons = {
  nextTitle?: string;
  step: number;
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  disabled?: boolean;

};
export default function AddTestPageNavButtons(fn: AddTestPageNavButtons) {
  const disabledBackButton = fn.step === 0;
  const disabledNextButton = fn.step === 4;
  const deployNextButton = fn.step === 2;
  return (
    <Box
      sx={{
        display: "grid",
        width: "100%",
        paddingY: "20px",
        paddingX: { md: "90px", sm: "50px" },
        gridTemplateColumns: "auto auto",
        marginTop: "auto",
      }}
    >
      <Button
        sx={{ width: 100 }}
        size={"large"}
        variant="contained"
        onClick={() => fn.handlePageChangeDown()}
        startIcon={<ArrowBack />}
        disabled={disabledBackButton}
      >
        Back
      </Button>
      <Button
        sx={{ width: 100, justifySelf: "end" }}
        size={"large"}
        variant="contained"
        onClick={() => fn.handlePageChangeUp()}
        endIcon={<ArrowForward />}
        disabled={disabledNextButton || fn.disabled}
      >
        {fn.nextTitle ? fn.nextTitle : "Next"}
      </Button>
    </Box>
  );
}
